module.exports = __webpack_public_path__ + "assets/1792649897182/img/unknown-icon.a9f30e60.png";